export const HIDDEN_TITLE = 'hidden';
export const BLANK_TITLE = 'blank';
export const HOME_TITLE = 'home';
export const MAIN_PAGE_TITLE = 'mainpage';
export const SUB_PAGE_TITLE = 'subpage';
export const BLANK_WITH_TITLE = 'blankwithtitle';
